<template>
  <div class="segbar"></div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array
    },
    options: {
      type: Object
    },
    type: {
      type: String
    }
  },
  methods: {
    /* eslint-disable */
    constructBar(element) {
      var percentages = this.getPercentages(this.data);

      for (let i = 0; i < this.data.length; i++) {
        this.data[i].percent = +percentages[i];
      }

      // Percent 계산문
      let totalPercent = 0;
      for (let i = this.data.length - 1; i >= 0; i--) {
        let percent = 0;
        if (i !== 0) {
          if (parseFloat(this.data[i].percent * 100) < 10) {
            totalPercent += 10;
            this.data[i].percent = 10;
          } else {
            percent = parseInt(this.data[i].percent * 100);
            this.data[i].percent = percent;
            totalPercent += percent;
          }
        } else {
          this.data[i].percent = 100 - parseInt(totalPercent);
        }
      }

      Object.values(this.data).forEach((item, index) => {
        var div = document.createElement('div');

        // wrapper
        div.style.width = parseInt(item.percent) + '%';
        div.style.backgroundColor = item.color;
        div.classList.add('item-wrapper');

        element.appendChild(div);
      });
    },
    getPercentages(data) {
      var sum = this.getSum(data);

      return data.map(function (item) {
        return parseFloat(item.value / sum);
      });
    },
    getSum(data) {
      return data.reduce(function (sum, item) {
        return sum + item.value;
      }, 0);
    },
    delDiv() {
      var delDiv = document.getElementsByClassName('segbar');
      var j = 0;

      for (var t = 0; t < delDiv.length; t++) {
        for (var i = delDiv[j].childElementCount - 1; i >= 0; i--) {
          if (j < delDiv.length) {
            delDiv[j].removeChild(delDiv[j].childNodes[i]);
            if (delDiv[j].childElementCount === 0) {
              j++;
            }
          }
        }
      }
    }
  },
  watch: {
    data() {
      this.delDiv();
      setTimeout(() => {
        this.constructBar(this.$el);
      }, 100);
    }
  },
  mounted() {
    this.constructBar(this.$el);
  }
};
</script>
